import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './FocusRing.module.css';

interface FocusRingProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  offset?: number;
}

export const FocusRing = forwardRef<HTMLDivElement, FocusRingProps>(
  ({ children, offset = 2, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(styles.focusRing, className)}
        style={{ '--focus-offset': `${offset}px`, ...style } as React.CSSProperties}
        {...props}
      >
        {children}
      </div>
    );
  }
);

FocusRing.displayName = 'FocusRing';
